import { TextInput } from "@validereinc/common-components";
import * as PropTypes from "prop-types";
import React from "react";
import { getSourceTitle } from "../../BalanceHelper";
import SourceInput from "../SourceInput";

const InventorySourceSelectionForm = ({
  sources,
  sourceAction,
  selectedSourceType,
  onSourceChecked,
}) => {
  return (
    <>
      <SourceInput
        // @ts-expect-error legacy opshub typing
        title={getSourceTitle(selectedSourceType)}
        sources={sources}
        onSourceChecked={onSourceChecked}
        showMultiplier={sourceAction === "edit" || sourceAction === "delete"}
        isInventory={true}
        disabled={false}
      />

      <TextInput
        name="multiplier"
        label="Multiplier"
        type="number"
        unit="x"
        placeholder="multiplier"
        isDisabled={false}
        rules={{
          validate: {
            validateMultiplier: (value) =>
              value <= 0 ? "Multiplier must be positive number." : undefined,
          },
        }}
        showIcon
        isRequired
      />
    </>
  );
};

InventorySourceSelectionForm.propTypes = {
  sources: PropTypes.array.isRequired,
  sourceAction: PropTypes.string.isRequired,
  selectedSourceType: PropTypes.string,
  onSourceChecked: PropTypes.func,
};

export default InventorySourceSelectionForm;
